'use strict';
import Swiper from 'swiper/js/swiper.min.js';

//-------------------------------------------------------
// INIT using routes in main.js
//-------------------------------------------------------
export default {
  init() {
    new ContentSwiper();
    new GallerySwiper();
    new CaseStudiesSwiper();
  },
};

//-------------------------------------------------------
// Content Swiper
//-------------------------------------------------------
function ContentSwiper()
{
  let self = this;

  this.init = function() {
    self.gallery = new Swiper('.content-slide', {
      slidesPerView: 1,
      pagination: {
        el: '.content-swiper-pagination',
          clickable: true,
      },
    });
  };

  setTimeout(self.init, 1000);
}

//-------------------------------------------------------
// Gallery Swiper
//-------------------------------------------------------
function GallerySwiper()
{
  let self = this;

  this.init = function() {
    self.gallery = new Swiper('.gallery-slide', {
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 30,
    });
  };

  setTimeout(self.init, 1000);
}

//-------------------------------------------------------
// Case Studies Swiper
//-------------------------------------------------------
function CaseStudiesSwiper()
{
  let self = this;

  this.init = function() {
    self.gallery = new Swiper('.case-studies-slide', {
      slidesPerView: 1,
      centeredSlides: true,
      spaceBetween: 20,
      grabCursor: true,
      pagination: {
        el: '.case-studies-swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        500: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 3,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 40,
        },
        1800: {
          slidesPerView: 6,
          spaceBetween: 50,
        },
      },
    });
  };

  self.init();
}



// WEBPACK FOOTER //
// ./scripts/routes/casestudy.js